import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchstyleGuideThunk } from "../redux/styleGuideSlice";

export default function useStyleGuideData() {
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector((state) => state.styleGuide);

    useEffect(() => {
        document.title = "Style Guide";

        // Prevent unnecessary API calls
        if (!data && !loading) {
            dispatch(fetchstyleGuideThunk());
        }
    }, [dispatch, data, loading]);

    return { data, loading, error };
}
